import { InfoRow } from "@/shared/components/ui/InfoRow";
import { Section } from "@/shared/components/ui/Section";
import { StatusBadge } from "@/shared/components/ui/StatusBadge";

const events = [
  { id: "booking-received", title: "Booking request received", description: "Acknowledges a customer's pending booking request." },
  { id: "appointment-confirmed", title: "Appointment confirmed", description: "Notifies the customer when an appointment is confirmed." },
  { id: "appointment-rescheduled", title: "Appointment rescheduled", description: "Notifies the customer when an appointment is rescheduled." },
  { id: "appointment-cancelled", title: "Appointment cancelled", description: "Notifies the customer when an appointment is cancelled." },
  { id: "booking-declined", title: "Booking declined", description: "Notifies the customer when a booking is declined." },
];

export function CustomerEmailEventsSection() {
  return (
    <Section title="Customer email events" action={<StatusBadge>Settings unavailable</StatusBadge>}>
      <p className="text-sm leading-relaxed text-muted-foreground">
        Individual customer-email controls are not available yet. These emails
        continue to follow the current system behaviour. Appointment reminders
        are managed separately above.
      </p>
      <div className="space-y-2">
        {events.map((event) => (
          <InfoRow key={event.id} title={event.title} caption={event.description} density="compact" />
        ))}
      </div>
      <p className="text-xs leading-relaxed text-muted-foreground">
        Only outgoing customer emails are listed here, not owner notifications or account emails.
      </p>
    </Section>
  );
}
